module.exports = __webpack_public_path__ + "static/media/help.f2c3f9a4.svg";